import FAApi from './_faVoucherListApi';
import httpClient from '@/apis/base/httpclient';

class FAVoucherDepreciationApi extends FAApi {
  controllerName = 'favoucherdepreciations';

  /**
 * Lấy danh sách phân trang khi thêm mới
 * @modified tvtoan 22.04.2024
 * @returns data
 */
  getDepreciationData(year, pagination, take, skip) {
    let request = {
      url: this.getAPIUrl() + `/GetDepreciationData`,
      data: {year: year, pagination: pagination, take: take, skip: skip }
    };
    return httpClient.getAsync(request);
  }

  /**
* Lấy danh sách phân trang khi edit
* @modified tvtoan 22.04.2024
* @returns data
*/
  getDataFixedAssetForEdit(id, take, skip, summary) {
    let request = {
      url: this.getAPIUrl() + `/DepreciationDataForEdit`,
      data: { id: id, take: take, skip: skip, summary: summary }
    };
    return httpClient.getAsync(request);
  }

  getDepreciationByYear(year){
    let request = {
      url: this.getAPIUrl() + `/GetDepreciationByYear`,
      data: {year: year}
    };
    return httpClient.getAsync(request);
  }

  /**
   * Lấy thông tin summary khi thêm mới
   * tvtoan 22.04.2024
   * @returns data
   */
  getSummaryDepreciationData(year) {
    let request = {
      url: this.getAPIUrl() + `/GetSummaryDepreciationData`,
      data: { year: year }
    };
    return httpClient.getAsync(request);
  }

    /**
   * Lấy thông tin summary khi edit
   * tvtoan 22.04.2024
   * @returns data
   */
    getDataFixedAssetSummaryForEdit(id, take, skip, summary) {
      let request = {
        url: this.getAPIUrl() + `/DepreciationDataSummaryForEdit`,
        data: { id: id, take: take, skip: skip, summary: summary }
      };
      return httpClient.getAsync(request);
    }

      /**
   * Lấy bản ghi mặc định khi thêm mới
   * tvtoan 25.04.2024 override
   */
  getEdit(payload) {
    const request = {
      url: this.getAPIUrl() + `/customEdit`,
      data: { id: payload.id, take: payload.take, skip: payload.skip }
    };

    return httpClient.getAsync(request);
  }
}

export default new FAVoucherDepreciationApi();
